// packages/shared/src/components/timesheet/TimesheetGrid.tsx
import type { TimesheetGrid as Grid } from '../../services/timeTracking/timesheetAggregate';
import { formatDuration } from '../../services/timeTracking/timeTrackingService';

interface Props {
  grid: Grid;
  dossierLabels: Record<string, string>;
}

export function TimesheetGrid({ grid, dossierLabels }: Props) {
  if (grid.rows.length === 0) {
    return <p className="py-12 text-center text-sm text-neutral-500">Aucune prestation sur cette période.</p>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="cime-table text-sm">
        <thead>
          <tr className="text-left">
            <th scope="col" className="px-3 py-2">Jour</th>
            {grid.dossierIds.map((id) => (
              <th scope="col" key={id} className="px-3 py-2">{dossierLabels[id] ?? id}</th>
            ))}
            <th scope="col" className="px-3 py-2">Total jour</th>
          </tr>
        </thead>
        <tbody>
          {grid.rows.map((row) => (
            <tr key={row.day}>
              <th scope="row" className="px-3 py-2">{row.day}</th>
              {grid.dossierIds.map((id) => {
                const c = row.cells[id];
                return (
                  <td key={id} className="px-3 py-2">
                    {c ? (
                      <>
                        {formatDuration(c.total)}
                        {c.nonBillable > 0 && (
                          <span className="ml-1 text-xs text-neutral-400">
                            (dont {formatDuration(c.nonBillable)} non fact.)
                          </span>
                        )}
                      </>
                    ) : '—'}
                  </td>
                );
              })}
              <td className="px-3 py-2 font-medium">{formatDuration(row.dayTotal)}</td>
            </tr>
          ))}
          <tr className="border-t-2 border-cime-border font-semibold">
            <th scope="row" className="px-3 py-2">Total dossier</th>
            {grid.dossierIds.map((id) => (
              <td key={id} className="px-3 py-2">{formatDuration(grid.dossierTotals[id] ?? 0)}</td>
            ))}
            <td className="px-3 py-2">{formatDuration(grid.grandTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
